/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TimeBucketEnum {
    DAY = 'day',
    ISO_WEEK = 'iso_week',
    MONTH = 'month',
    YEAR = 'year',
}
